import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-preload-img',
    templateUrl: './preload-img.component.html',
    styleUrls: ['./preload-img.component.scss'],
    standalone: false
})
export class PreloadImgComponent implements OnInit {
  noImage = '';
  loadingImage = '../../../../assets/img/loadingg.gif';
  bannerImage = '../../../../assets/img/banner.jpg';

  constructor() { }

  ngOnInit(): void {
  }

  isInViewport(item: any, id?: string) {
    let rect;
    const selector = id ? id : item.name;
    const el = document.getElementById(selector);
    if (el) {
      if (!item.home) {
        rect = el.getBoundingClientRect();
        if (rect) {
          if (
            rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.bottom > 0
          ) {
            el.setAttribute('src', item.photo);
            el.classList.add('fadeIn');
          } else if (window.innerWidth > 900) {
            el.setAttribute('src', item.photo);
          }
        }
      } else {
        el.setAttribute('src', item.photo);
      }
    }
    return item.name;
  }

}
